/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createStaff = /* GraphQL */ `
  mutation CreateStaff(
    $input: CreateStaffInput!
    $condition: ModelStaffConditionInput
  ) {
    createStaff(input: $input, condition: $condition) {
      id
      name
      active
      createdAt
      updatedAt
    }
  }
`;
export const updateStaff = /* GraphQL */ `
  mutation UpdateStaff(
    $input: UpdateStaffInput!
    $condition: ModelStaffConditionInput
  ) {
    updateStaff(input: $input, condition: $condition) {
      id
      name
      active
      createdAt
      updatedAt
    }
  }
`;
export const deleteStaff = /* GraphQL */ `
  mutation DeleteStaff(
    $input: DeleteStaffInput!
    $condition: ModelStaffConditionInput
  ) {
    deleteStaff(input: $input, condition: $condition) {
      id
      name
      active
      createdAt
      updatedAt
    }
  }
`;
export const createTimeSheet = /* GraphQL */ `
  mutation CreateTimeSheet(
    $input: CreateTimeSheetInput!
    $condition: ModelTimeSheetConditionInput
  ) {
    createTimeSheet(input: $input, condition: $condition) {
      id
      staffID
      arrivalTime
      departureTime
      createdAt
      updatedAt
    }
  }
`;
export const updateTimeSheet = /* GraphQL */ `
  mutation UpdateTimeSheet(
    $input: UpdateTimeSheetInput!
    $condition: ModelTimeSheetConditionInput
  ) {
    updateTimeSheet(input: $input, condition: $condition) {
      id
      staffID
      arrivalTime
      departureTime
      createdAt
      updatedAt
    }
  }
`;
export const deleteTimeSheet = /* GraphQL */ `
  mutation DeleteTimeSheet(
    $input: DeleteTimeSheetInput!
    $condition: ModelTimeSheetConditionInput
  ) {
    deleteTimeSheet(input: $input, condition: $condition) {
      id
      staffID
      arrivalTime
      departureTime
      createdAt
      updatedAt
    }
  }
`;
export const createInvoice = /* GraphQL */ `
  mutation CreateInvoice(
    $input: CreateInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    createInvoice(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      paymentDate
      insurer
      claimNo
      patient
      provider
      amount
      paymentType
      note
      invoiceDoc
      chequeDoc
      status
      claimDisbursedToProvider
      createdBy
      updatedBy
    }
  }
`;
export const updateInvoice = /* GraphQL */ `
  mutation UpdateInvoice(
    $input: UpdateInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    updateInvoice(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      paymentDate
      insurer
      claimNo
      patient
      provider
      amount
      paymentType
      note
      invoiceDoc
      chequeDoc
      status
      claimDisbursedToProvider
      createdBy
      updatedBy
    }
  }
`;
export const deleteInvoice = /* GraphQL */ `
  mutation DeleteInvoice(
    $input: DeleteInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    deleteInvoice(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      paymentDate
      insurer
      claimNo
      patient
      provider
      amount
      paymentType
      note
      invoiceDoc
      chequeDoc
      status
      claimDisbursedToProvider
      createdBy
      updatedBy
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      productCode
      category
      description
      storeID
      store {
        id
        name
        createdAt
        updatedAt
      }
      audits {
        items {
          id
          productID
          auditID
          expiry
          qty
          product {
            id
            productCode
            category
            description
            storeID
            package
            qty
            minStockQty
            supplier
            obsolete
            createdAt
            updatedAt
          }
          audit {
            id
            name
            note
            auditFrequency
            createdAt
            updatedAt
          }
          shelfID
          shelf {
            id
            name
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      package
      qty
      minStockQty
      supplier
      obsolete
      createdAt
      updatedAt
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      productCode
      category
      description
      storeID
      store {
        id
        name
        createdAt
        updatedAt
      }
      audits {
        items {
          id
          productID
          auditID
          expiry
          qty
          product {
            id
            productCode
            category
            description
            storeID
            package
            qty
            minStockQty
            supplier
            obsolete
            createdAt
            updatedAt
          }
          audit {
            id
            name
            note
            auditFrequency
            createdAt
            updatedAt
          }
          shelfID
          shelf {
            id
            name
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      package
      qty
      minStockQty
      supplier
      obsolete
      createdAt
      updatedAt
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      productCode
      category
      description
      storeID
      store {
        id
        name
        createdAt
        updatedAt
      }
      audits {
        items {
          id
          productID
          auditID
          expiry
          qty
          product {
            id
            productCode
            category
            description
            storeID
            package
            qty
            minStockQty
            supplier
            obsolete
            createdAt
            updatedAt
          }
          audit {
            id
            name
            note
            auditFrequency
            createdAt
            updatedAt
          }
          shelfID
          shelf {
            id
            name
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      package
      qty
      minStockQty
      supplier
      obsolete
      createdAt
      updatedAt
    }
  }
`;
export const createStore = /* GraphQL */ `
  mutation CreateStore(
    $input: CreateStoreInput!
    $condition: ModelStoreConditionInput
  ) {
    createStore(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const updateStore = /* GraphQL */ `
  mutation UpdateStore(
    $input: UpdateStoreInput!
    $condition: ModelStoreConditionInput
  ) {
    updateStore(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const deleteStore = /* GraphQL */ `
  mutation DeleteStore(
    $input: DeleteStoreInput!
    $condition: ModelStoreConditionInput
  ) {
    deleteStore(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const createShelf = /* GraphQL */ `
  mutation CreateShelf(
    $input: CreateShelfInput!
    $condition: ModelShelfConditionInput
  ) {
    createShelf(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const updateShelf = /* GraphQL */ `
  mutation UpdateShelf(
    $input: UpdateShelfInput!
    $condition: ModelShelfConditionInput
  ) {
    updateShelf(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const deleteShelf = /* GraphQL */ `
  mutation DeleteShelf(
    $input: DeleteShelfInput!
    $condition: ModelShelfConditionInput
  ) {
    deleteShelf(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const createProductAudit = /* GraphQL */ `
  mutation CreateProductAudit(
    $input: CreateProductAuditInput!
    $condition: ModelProductAuditConditionInput
  ) {
    createProductAudit(input: $input, condition: $condition) {
      id
      productID
      auditID
      expiry
      qty
      product {
        id
        productCode
        category
        description
        storeID
        store {
          id
          name
          createdAt
          updatedAt
        }
        audits {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        package
        qty
        minStockQty
        supplier
        obsolete
        createdAt
        updatedAt
      }
      audit {
        id
        name
        products {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        note
        auditFrequency
        createdAt
        updatedAt
      }
      shelfID
      shelf {
        id
        name
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateProductAudit = /* GraphQL */ `
  mutation UpdateProductAudit(
    $input: UpdateProductAuditInput!
    $condition: ModelProductAuditConditionInput
  ) {
    updateProductAudit(input: $input, condition: $condition) {
      id
      productID
      auditID
      expiry
      qty
      product {
        id
        productCode
        category
        description
        storeID
        store {
          id
          name
          createdAt
          updatedAt
        }
        audits {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        package
        qty
        minStockQty
        supplier
        obsolete
        createdAt
        updatedAt
      }
      audit {
        id
        name
        products {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        note
        auditFrequency
        createdAt
        updatedAt
      }
      shelfID
      shelf {
        id
        name
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteProductAudit = /* GraphQL */ `
  mutation DeleteProductAudit(
    $input: DeleteProductAuditInput!
    $condition: ModelProductAuditConditionInput
  ) {
    deleteProductAudit(input: $input, condition: $condition) {
      id
      productID
      auditID
      expiry
      qty
      product {
        id
        productCode
        category
        description
        storeID
        store {
          id
          name
          createdAt
          updatedAt
        }
        audits {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        package
        qty
        minStockQty
        supplier
        obsolete
        createdAt
        updatedAt
      }
      audit {
        id
        name
        products {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        note
        auditFrequency
        createdAt
        updatedAt
      }
      shelfID
      shelf {
        id
        name
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createAudit = /* GraphQL */ `
  mutation CreateAudit(
    $input: CreateAuditInput!
    $condition: ModelAuditConditionInput
  ) {
    createAudit(input: $input, condition: $condition) {
      id
      name
      products {
        items {
          id
          productID
          auditID
          expiry
          qty
          product {
            id
            productCode
            category
            description
            storeID
            package
            qty
            minStockQty
            supplier
            obsolete
            createdAt
            updatedAt
          }
          audit {
            id
            name
            note
            auditFrequency
            createdAt
            updatedAt
          }
          shelfID
          shelf {
            id
            name
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      note
      auditFrequency
      createdAt
      updatedAt
    }
  }
`;
export const updateAudit = /* GraphQL */ `
  mutation UpdateAudit(
    $input: UpdateAuditInput!
    $condition: ModelAuditConditionInput
  ) {
    updateAudit(input: $input, condition: $condition) {
      id
      name
      products {
        items {
          id
          productID
          auditID
          expiry
          qty
          product {
            id
            productCode
            category
            description
            storeID
            package
            qty
            minStockQty
            supplier
            obsolete
            createdAt
            updatedAt
          }
          audit {
            id
            name
            note
            auditFrequency
            createdAt
            updatedAt
          }
          shelfID
          shelf {
            id
            name
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      note
      auditFrequency
      createdAt
      updatedAt
    }
  }
`;
export const deleteAudit = /* GraphQL */ `
  mutation DeleteAudit(
    $input: DeleteAuditInput!
    $condition: ModelAuditConditionInput
  ) {
    deleteAudit(input: $input, condition: $condition) {
      id
      name
      products {
        items {
          id
          productID
          auditID
          expiry
          qty
          product {
            id
            productCode
            category
            description
            storeID
            package
            qty
            minStockQty
            supplier
            obsolete
            createdAt
            updatedAt
          }
          audit {
            id
            name
            note
            auditFrequency
            createdAt
            updatedAt
          }
          shelfID
          shelf {
            id
            name
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      note
      auditFrequency
      createdAt
      updatedAt
    }
  }
`;
export const createPurchaseOrder = /* GraphQL */ `
  mutation CreatePurchaseOrder(
    $input: CreatePurchaseOrderInput!
    $condition: ModelPurchaseOrderConditionInput
  ) {
    createPurchaseOrder(input: $input, condition: $condition) {
      id
      name
      orderDoc
      invoiceDoc
      receiptDoc
      orderStatus
      delivered
      createdBy
      updatedBy
      createdAt
      amount
      supplier
      items {
        items {
          id
          productID
          purchaseOrderID
          qty
          price
          product {
            id
            productCode
            category
            description
            storeID
            package
            qty
            minStockQty
            supplier
            obsolete
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const updatePurchaseOrder = /* GraphQL */ `
  mutation UpdatePurchaseOrder(
    $input: UpdatePurchaseOrderInput!
    $condition: ModelPurchaseOrderConditionInput
  ) {
    updatePurchaseOrder(input: $input, condition: $condition) {
      id
      name
      orderDoc
      invoiceDoc
      receiptDoc
      orderStatus
      delivered
      createdBy
      updatedBy
      createdAt
      amount
      supplier
      items {
        items {
          id
          productID
          purchaseOrderID
          qty
          price
          product {
            id
            productCode
            category
            description
            storeID
            package
            qty
            minStockQty
            supplier
            obsolete
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const deletePurchaseOrder = /* GraphQL */ `
  mutation DeletePurchaseOrder(
    $input: DeletePurchaseOrderInput!
    $condition: ModelPurchaseOrderConditionInput
  ) {
    deletePurchaseOrder(input: $input, condition: $condition) {
      id
      name
      orderDoc
      invoiceDoc
      receiptDoc
      orderStatus
      delivered
      createdBy
      updatedBy
      createdAt
      amount
      supplier
      items {
        items {
          id
          productID
          purchaseOrderID
          qty
          price
          product {
            id
            productCode
            category
            description
            storeID
            package
            qty
            minStockQty
            supplier
            obsolete
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const createItem = /* GraphQL */ `
  mutation CreateItem(
    $input: CreateItemInput!
    $condition: ModelItemConditionInput
  ) {
    createItem(input: $input, condition: $condition) {
      id
      productID
      purchaseOrderID
      qty
      price
      product {
        id
        productCode
        category
        description
        storeID
        store {
          id
          name
          createdAt
          updatedAt
        }
        audits {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        package
        qty
        minStockQty
        supplier
        obsolete
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateItem = /* GraphQL */ `
  mutation UpdateItem(
    $input: UpdateItemInput!
    $condition: ModelItemConditionInput
  ) {
    updateItem(input: $input, condition: $condition) {
      id
      productID
      purchaseOrderID
      qty
      price
      product {
        id
        productCode
        category
        description
        storeID
        store {
          id
          name
          createdAt
          updatedAt
        }
        audits {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        package
        qty
        minStockQty
        supplier
        obsolete
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteItem = /* GraphQL */ `
  mutation DeleteItem(
    $input: DeleteItemInput!
    $condition: ModelItemConditionInput
  ) {
    deleteItem(input: $input, condition: $condition) {
      id
      productID
      purchaseOrderID
      qty
      price
      product {
        id
        productCode
        category
        description
        storeID
        store {
          id
          name
          createdAt
          updatedAt
        }
        audits {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        package
        qty
        minStockQty
        supplier
        obsolete
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createReport = /* GraphQL */ `
  mutation CreateReport(
    $input: CreateReportInput!
    $condition: ModelReportConditionInput
  ) {
    createReport(input: $input, condition: $condition) {
      id
      tag
      amount
      createdAt
      createdBy
      reportFile
      updatedAt
    }
  }
`;
export const updateReport = /* GraphQL */ `
  mutation UpdateReport(
    $input: UpdateReportInput!
    $condition: ModelReportConditionInput
  ) {
    updateReport(input: $input, condition: $condition) {
      id
      tag
      amount
      createdAt
      createdBy
      reportFile
      updatedAt
    }
  }
`;
export const deleteReport = /* GraphQL */ `
  mutation DeleteReport(
    $input: DeleteReportInput!
    $condition: ModelReportConditionInput
  ) {
    deleteReport(input: $input, condition: $condition) {
      id
      tag
      amount
      createdAt
      createdBy
      reportFile
      updatedAt
    }
  }
`;
export const createNswPublicHoliday = /* GraphQL */ `
  mutation CreateNswPublicHoliday(
    $input: CreateNSWPublicHolidayInput!
    $condition: ModelNSWPublicHolidayConditionInput
  ) {
    createNSWPublicHoliday(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const updateNswPublicHoliday = /* GraphQL */ `
  mutation UpdateNswPublicHoliday(
    $input: UpdateNSWPublicHolidayInput!
    $condition: ModelNSWPublicHolidayConditionInput
  ) {
    updateNSWPublicHoliday(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const deleteNswPublicHoliday = /* GraphQL */ `
  mutation DeleteNswPublicHoliday(
    $input: DeleteNSWPublicHolidayInput!
    $condition: ModelNSWPublicHolidayConditionInput
  ) {
    deleteNSWPublicHoliday(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const createContact = /* GraphQL */ `
  mutation CreateContact(
    $input: CreateContactInput!
    $condition: ModelContactConditionInput
  ) {
    createContact(input: $input, condition: $condition) {
      id
      firstName
      lastName
      phone
      email
      companyName
      createdAt
      updatedAt
    }
  }
`;
export const updateContact = /* GraphQL */ `
  mutation UpdateContact(
    $input: UpdateContactInput!
    $condition: ModelContactConditionInput
  ) {
    updateContact(input: $input, condition: $condition) {
      id
      firstName
      lastName
      phone
      email
      companyName
      createdAt
      updatedAt
    }
  }
`;
export const deleteContact = /* GraphQL */ `
  mutation DeleteContact(
    $input: DeleteContactInput!
    $condition: ModelContactConditionInput
  ) {
    deleteContact(input: $input, condition: $condition) {
      id
      firstName
      lastName
      phone
      email
      companyName
      createdAt
      updatedAt
    }
  }
`;
